
class SpritesheetAnimate {

	static get spriteAnimationsAr() {
		if (!this._spriteAnimationsAr) {
			this._spriteAnimationsAr = []; // Initialize the array if it doesn't exist
		}
		return this._spriteAnimationsAr;
	}

	static _draw(tAnimation) {
		// draw if there are any sprites currently playing
		if (tAnimation.isPlaying) {
			setTimeout(function () {
				SpritesheetAnimate._draw(tAnimation);
			},
				tAnimation.speed * 1000);
			if (tAnimation.direction === "horz") {
				tAnimation.el.style.backgroundPosition = '-' + tAnimation.displayW * tAnimation.curFrame + 'px 0px';
			} else {
				tAnimation.el.style.backgroundPosition = ' 0px -' + tAnimation.displayH * tAnimation.curFrame + 'px';
			}
			tAnimation.curFrame++;
			if (tAnimation.curFrame >= tAnimation.totalFrames - 1) {
				tAnimation.curFrame = 0;
			}
		}
	}

	static _resetSprite(tAnimObj) {
		if (tAnimObj) {
			tAnimObj.curLoopNum = 1;
			tAnimObj.curFrame = 0;
			tAnimObj.isPlaying = false;
			if (tAnimObj.el) {
				tAnimObj.el.style.backgroundPosition = '0px 0px';
			}
		}
	}

	/* GETS THE REGISTERED ELEMENT'S INDEX FOR USE IN ANIMATION */
	static _getAnimationIndex(tID) {
		const total = SpritesheetAnimate.spriteAnimationsAr.length;
		let i;
		for (i = 0; i < total; i++) {
			if (SpritesheetAnimate.spriteAnimationsAr[i].id === tID) {
				return i;
			}
		}
		return null;
	}

	//registerSprite('stars1', document.getElementsByClassName('test-sprite')[0], 400, 400, 165, 7920, .02, 9999);
	//playSprite('stars1'); // Tell sprite to play

	static reset() {
		SpritesheetAnimate.resetAllSprites();
	}

	/* REGISTER THE SPRITE FOR USAGE */
	static registerSprite(id, img, el, displayW, totalW, displayH, totalH, speed, numLoops) {
		var spriteDir = (displayW === totalW) ? 'vert' : 'horz',
			spriteTotalFrames = (spriteDir === "vert") ? totalH / displayH : totalW / displayW;

		SpritesheetAnimate.spriteAnimationsAr.push({
			id: id,
			img: img,
			el: el,
			displayW: displayW,
			displayH: displayH,
			curFrame: 0,
			totalFrames: spriteTotalFrames,
			direction: spriteDir,
			speed: speed,
			curLoopNum: 1,
			totalLoops: numLoops
		});
	}

	static registerSpriteObj(tSprite) {
		SpritesheetAnimate.spriteAnimationsAr.push(tSprite);
	}

	/* PLAY SPRITE BY FIRST RESETTING IT, THEN TELLING IT TO ANIMATE */
	static playSprite(tID, tEl) {
		var index = SpritesheetAnimate._getAnimationIndex(tID),
			tAnimation;
		if (!isNaN(index)) {
			tAnimation = SpritesheetAnimate.spriteAnimationsAr[index];
			if (tEl) {
				tAnimation.el = tEl;
			}
			SpritesheetAnimate._resetSprite(tAnimation);
			tAnimation.isPlaying = true;
			SpritesheetAnimate._draw(tAnimation);
		} else {
			console.warn('[SpritesheetAnimate].playSprite: index not found: ', tID);
		}
	}

	/* RESETS ALL THE SPRITES */
	static resetAllSprites() {
		//console.log('[SpritesheetAnimate].resetAllSprites', SpritesheetAnimate.spriteAnimationsAr);
		var total = SpritesheetAnimate.spriteAnimationsAr.length,
			i;
		for (i = 0; i < total; i++) {
			//console.log('[SpritesheetAnimate].reset sprite '+SpritesheetAnimate.spriteAnimationsAr[i].id);
			SpritesheetAnimate._resetSprite(SpritesheetAnimate.spriteAnimationsAr[i]);
		}
	}

	/* RESETS INDIVIDUAL SPRITE */
	static resetSprite(tID) {
		var index = SpritesheetAnimate._getAnimationIndex(tID);
		if (!isNaN(index)) {
			SpritesheetAnimate._resetSprite(SpritesheetAnimate.spriteAnimationsAr[index]);
		} else {
			console.warn('[spriteAnimator].resetSprite: index not found', tID);
		}
	}
}
export default SpritesheetAnimate;